import ContactMeLinkListlinks from "./ContactMeLinkListLinks";

function ContactMeLinkList(){

    return(

        <>

            <div>

                <div className="h1">Links</div>
                <div className="d-block py-3 w-50">
                    <ContactMeLinkListlinks />
                </div>

            </div>
        </>
    );
}

export default ContactMeLinkList;